import ThemeOptions from "./ThemeOptions";
import { appReducer } from "./app-reducer";

export default {
  ThemeOptions,
  appState: appReducer,
};
